<!-- <div class="back-overlay">
</div> -->
<div class="offer-bottom-popup" style="background: transparent !important;">
  
  <ion-card style="background: #fff;">
    <ion-card-header>
      <ion-card-subtitle style="color: #7d7d7d;">Pay Using 100% Secured Option<ion-icon name="close-outline" (click)="close(false)"
          style="float: right;font-size: 1.5rem;"></ion-icon>
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content style="padding: 0;" [ngClass]="{'ios-bottom-safe-area': isIOSDevice}">
      <!-- <ion-card style="border-radius: 30px;position: relative;padding: 10px;"> -->
      <!-- <ion-card style="border-radius: 20px;position: relative;padding: 10px;background: transparent;box-shadow: none;">
        <ion-row>
          <ion-col class="ion-text-center" style="padding: 0 15px;" size="6">
            <div *ngFor="let plan of planData; let i = index">
              <ion-card [ngStyle]="{'width': plan.perid == 1 ? '80%' : plan.perid > 1 && plan.perid < 12 ?  '82%' : '88%' }" style="background: #fff;border-radius: 10px;border: 1px solid #80808040;box-shadow: none;width: 81%;left: 20px;" *ngIf="i == selectedIndex">
                <ion-card-header   [ngStyle]="{'background-color':color[i]}" style="padding: 5px 20px;">
                  <ion-card-title style="color: #fff;font-size: 1rem;">
                    <span class="result-title">{{plan.perid}}
                      <span *ngIf="plan.perid == 1">Month</span>
                      <span *ngIf="plan.perid > 1">Months</span>
                    </span>
                  </ion-card-title>
                </ion-card-header>  

                <ion-row>
                  <ion-col class="ion-text-center ion-align-self-end" style="padding: 10px  0;">
                    <h2 class="discount" [ngStyle]="{'color':color[i]}" style="font-size: 1rem;"
                      *ngIf="plan.discount!='0%'">
                      <b>{{plan.discount}} Off</b>
                    </h2>

                    <p style="font-size: 1.1rem;margin: 2px;font-weight: bold;" [ngStyle]="{'color':color[i]}">
                      ₹{{plan.discountedAmount}}
                    </p>
                    <span style="font-size: 0.9rem;" [ngStyle]="{'color':color[i]}">(₹{{
                      getRoundedAmount(plan.discountedAmount,plan.perid)}}/
                      <span style="font-size:.751rem;">month)</span>
                    </span>

                  </ion-col>
                </ion-row>
              </ion-card>
            </div>
          </ion-col>
          <ion-col  class="ion-align-self-center">
            <img src="./assets/img/refund.jpg" style="padding: 20px;">
          </ion-col>
        </ion-row>
      </ion-card>
        <ion-row style="padding-bottom: 10px;">
          <ion-col style="padding-left: 20px;
          margin-bottom: -10px;">
            <span style="color: #363939;
            font-size: 1rem;
            font-weight: 500;">Payment secured by </span><img src="./assets/img/reazor-pay-txt.png" style="width: 11vh;
    height: 2.5vh;
    margin-bottom: -5px;">
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col style="height: 7vh;
          padding: 5px 0;" (click)="close('razorpay')">
            <ion-card class="ion-text-center" style="border-radius: 30px;width: 100%;">
              <ion-row>
                <ion-col size="3" class="ion-text-end">
                  <img src="./assets/img/master-icon.jpg" style="height: 5vh;padding: 5px 0;">
                </ion-col>
                <ion-col size="3" class="ion-text-center">
                  <img src="./assets/img/visa-icon.png" style="height: 5vh;padding: 5px 0;">
                </ion-col>
                <ion-col size="3" class="ion-text-center">
                  <img src="./assets/img/RuPay-icon.jpeg" style="height: 5vh;padding: 5px 0 0 0;">
                </ion-col>
                <ion-col size="3" class="ion-text-start">
                  <img src="./assets/img/upi-icon.png" style="height: 5vh;padding: 5px 0;">
                </ion-col>
              </ion-row>
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-align-self-center" (click)="close('googlepay')">
            <ion-card class="ion-text-center" style="border-radius: 30px;">
              <img src="./assets/img/google-pay-new.jpeg" style="height: 5vh;
              padding: 5px 0;">
            </ion-card>
            
          </ion-col>
        </ion-row> -->
      
        <ion-list  lines="none">
          <ion-item (click)="close('razorpay')" style="border-bottom: 1px solid #b5b5b5;" [ngStyle]="{'height': isIOSDevice ? '50px' : '45px'}">
            <ion-avatar slot="start" style="border-radius:unset">
              <img src="./assets/img/razorpay_pay_new.jpg"  style="border-radius:unset">
            </ion-avatar>
            <ion-label style="text-overflow: unset;white-space: unset;">
              <h2>Card / Netbanking / UPI / Wallet</h2>
              <p *ngIf="allow7DaysRefund">Charging is done before & 7 day refund on request</p>
            </ion-label>
          </ion-item>

          <ion-item (click)="close('googlepay')" *ngIf="isAndroidDevice">
            <ion-avatar slot="start"  style="border-radius:unset">
              <img src="./assets/img/google_pay_new.png"  style="border-radius:unset">
            </ion-avatar>
            <ion-label style="text-overflow: unset;white-space: unset;">
              <h2>Google Pay</h2>
              <p *ngIf="allow7DaysRefund">Charging is done before & 7 day refund on request</p>
            </ion-label>
          </ion-item>

          <ion-item (click)="close('apple')" *ngIf="isIOSDevice" style="height: 50px;">
            <ion-avatar slot="start"  style="border-radius:unset">
              <img src="./assets/img/apple-logo.svg"  style="border-radius:unset;object-fit: contain;">
            </ion-avatar>
            <ion-label style="text-overflow: unset;white-space: unset;">
              <h2>Apple Pay</h2>
              <p *ngIf="allow7DaysRefund">Charging is done before & 7 day refund on request</p>
            </ion-label>
          </ion-item>
        </ion-list>

    </ion-card-content>
  </ion-card>
</div>